import React, { useEffect } from 'react';
import { BrowserRouter, Link, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import { Home, About, Projects, Contact } from './pages';
import ProjectPage from './pages/ProjectPage';
import { projects } from './data/projects';
import './App.css';

export function Site() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return <>
    <SEO />
    <a className="skip-link" href="#main">Skip to content</a>
    <Navbar />
    <main id="main" tabIndex={-1}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        {projects.map(project => <Route key={project.id} path={`/projects/${project.id}`} element={<ProjectPage project={project} />} />)}
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<section className="container page-intro"><p className="eyebrow">404</p><h1>Page not found.</h1><p>Explore our products or head back to the homepage.</p><Link className="button" to="/">Back to home <span aria-hidden="true">↗</span></Link></section>} />
      </Routes>
    </main>
    <Footer />
  </>;
}

export default function App() {
  return <BrowserRouter><Site /></BrowserRouter>;
}
